import { container } from "tsyringe";
import { AuthClient } from "./authClient";
import { LoginDto } from "../../generated-client";
import { setAuthFromToken } from "ang/order_portal/model/authStore";
import "reflect-metadata";

type LoginResponse = { access_token: string };

function isLoginResponse(x: unknown): x is LoginResponse {
	return !!x && typeof (x as any).access_token === "string";
}

export class AuthService {
	private readonly authClient: AuthClient = container.resolve(AuthClient);

	public async login(loginDto: LoginDto): Promise<LoginResponse> {
		const res: unknown = await this.authClient.authApi.authControllerLogin({
			loginDto,
		});

		if (!isLoginResponse(res)) {
			throw new Error("No access token received");
		}

		setAuthFromToken(res.access_token);
		return res;
	}
}
